import { today } from './when'

export const briefMetricLabels = [
  { key: 'followed_customers', label: '跟进涉及客户', unit: '位' },
  { key: 'follow_up_records', label: '录入跟进记录', unit: '条' },
  { key: 'visit_customers', label: '录入来访客户', unit: '位' },
  { key: 'deals', label: '归属成交', unit: '套' }
]
export function briefValue(value) {
  return typeof value === 'number' && isFinite(value) && value >= 0 ? value : '—'
}
export function briefDate(value) {
  return /^\d{4}-\d{2}-\d{2}$/.test(String(value || '')) ? value : today()
}
export function briefReviewPeriod(brief) {
  const days = brief && brief.review_range && brief.review_range.days
  return typeof days === 'number' && days > 1 && days <= 31 && Math.floor(days) === days ? '近' + days + '天' : '昨日'
}
export function briefReviewTitle(brief) {
  return briefReviewPeriod(brief) + '复盘'
}
export function briefState(brief) {
  if (!brief) return '读取晨报'
  if (brief.status === 'ready') return 'AI 已分析'
  if (brief.status === 'empty') return '暂无新资料'
  if (brief.status === 'missing') return '未留存'
  if (['pending', 'processing', 'waiting'].indexOf(brief.status) >= 0) return '准备中'
  return '基础简报'
}
export function normalizeBrief(data) {
  if (!data || typeof data !== 'object' || !/^\d{4}-\d{2}-\d{2}$/.test(data.date || '')) throw new Error('晨报数据暂不可用')
  const raw = data.analysis && typeof data.analysis === 'object' ? data.analysis : {}
  const plan = data.plan && typeof data.plan === 'object' ? data.plan : {}
  const range = data.review_range
  const validRange = range && typeof range.days === 'number' && range.days >= 1 && range.days <= 31 && Math.floor(range.days) === range.days
    && /^\d{4}-\d{2}-\d{2}$/.test(range.start || '') && /^\d{4}-\d{2}-\d{2}$/.test(range.end || '') && range.start <= range.end
  return Object.assign({}, data, {
    review_range: validRange ? range : null,
    stats: data.stats || {},
    analysis: {
      summary: raw.summary && typeof raw.summary.text === 'string' ? raw.summary : { text: '', evidence: [] },
      highlights: Array.isArray(raw.highlights) ? raw.highlights : [],
      risks: Array.isArray(raw.risks) ? raw.risks : [],
      priorities: Array.isArray(raw.priorities) ? raw.priorities : []
    },
    plan: Object.assign({ events_total: null, tasks_total: null }, plan, {
      events: Array.isArray(plan.events) ? plan.events : [], tasks: Array.isArray(plan.tasks) ? plan.tasks : [],
      errors: Array.isArray(plan.errors) ? plan.errors : []
    }),
    sources: Array.isArray(data.sources) ? data.sources : []
  })
}



// WEBPACK FOOTER //
// ./src/common/daily-brief.js